import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useNavigationData } from '../hooks/useNavigationData';
import { handleLanguageSwitcherItems } from '../hooks/handleLanguageSwitcherItems';
import useMobileView from '../hooks/useMobileView';

export const LanguageSwitcherItemsHandler = ({
	pageTitle,
}: {
	pageTitle: string;
}) => {
	const { flattenRoutes } = useNavigationData();
	const isMobile = useMobileView(1023);

	const location = useLocation();
	useEffect(() => {
		if (!flattenRoutes || flattenRoutes.length === 0) return;

		handleLanguageSwitcherItems(flattenRoutes, isMobile);
		document.title = `${pageTitle} - Bank of Cyprus`;
    
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.href, isMobile]);
	return <></>;
};
